import React from "react";
import "./styles.scss";

const Loading: React.FC = () => {
  return (
    <div className="flex h-full">
      <div className="loading-spinner m-auto"></div>
    </div>
  );
};

export default Loading;
